import { success } from '@react/react-spectrum/Toast';
import React from 'react';

import HelpSupportGridListItem from './HelpSupportGridListItem';

const handleClick = (text) => {
  navigator.clipboard.writeText(text);
  success('Copied to clipboard', {
    timeout: 3000,
    closable: false,
  });
};

const CopyShareLink = ({ label, icon, loading, isDisabled, text }) => {
  return (
    <HelpSupportGridListItem
      icon={icon}
      label={label}
      loading={loading}
      dataLaunchId="Help and Support : Copy Share Link"
      onClick={() => {
        if (!isDisabled) {
          handleClick(text);
        }
      }}
    />
  );
};

export { CopyShareLink };
